<template>
  <v-app-bar
    id="app-bar"
    fixed
    clipped-left
    app
    color="darken-3"
    dark 
    dense
    height="64"  
  >


    <!-- The bottom navigation bar covers mobile/tablet, so the hamburger is
         no longer rendered at that breakpoint. -->
    <v-toolbar-title v-if="isMobileMode" v-text="$route.name" style="color: white" />

    <template v-if="!isMobileMode">
      <v-tabs id="topmenu">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          class="titem"
          v-for="(item,index) in menus"
          :key="index" 
          @click="reroute(item)"
        >{{item.title }}</v-tab>
      </v-tabs> 
    </template>

    <v-spacer></v-spacer> 
    <v-autocomplete
            v-model="search"
            :items="drpObjectsOnly"
            color="green"
            flat
            solo-inverted
            label="Search Vehicle"
            class="hidden-sm-and-down pt-5 mt-2"
            item-text="name"
            item-value="imei" 
            @change="applySearch(search)" 
            prepend-inner-icon="mdi-magnify" 
          ></v-autocomplete>

    <v-spacer></v-spacer> 

     <v-menu bottom left offset-y origin="top right" transition="scale-transition">
      <template v-slot:activator="{ attrs, on }">
         <v-btn icon title="Alerts" v-on="on" >
          <v-badge color="red" overlap>
            <template v-slot:badge>
              <span>{{events.unread_events.length}}</span>
            </template>
            <v-icon medium color="white">mdi-bell</v-icon>
          </v-badge>
        </v-btn>
      </template> 

       <v-list two-line style="background: #fff"  max-height="450px" >  
            <v-list-item-group  style="background: #fff"> 
                    <v-list-item v-for="(alert, i) in events.unread_events" :key="i"  color="#ffffff" style="background: #fff" link @click="loadClickedEvent(alert.event_id)"  > 
                      <v-list-item-content>  
                          <v-list-item-title style="color: #000000" v-text="alert.name"></v-list-item-title>
                          <span class="pt-2"></span>  
                          <v-list-item-subtitle v-text="alert.event_desc"></v-list-item-subtitle> 

                        </v-list-item-content> 

                        <v-list-item-action>
                                <v-list-item-action-text v-text="extractTime(alert.dt_tracker)"></v-list-item-action-text>
                                <v-list-item-action-text v-text="alert.speed+' KPH'"></v-list-item-action-text> 
                        </v-list-item-action>   
                    </v-list-item> 
            </v-list-item-group>  
      </v-list> 
    </v-menu>


    <v-btn
      class="ml-2"
      color="white"
      v-if="playNotifications"
      @click="playNotifications=!playNotifications"
      min-width="0"
      text
    >
      <v-icon medium>mdi-volume-source</v-icon>
    </v-btn>

    <v-btn
      class="ml-2"
      color="white"
      @click="playNotifications=!playNotifications"
      v-else
      min-width="0"
      text
    >
      <v-icon medium>mdi-volume-mute</v-icon>
    </v-btn>

    <v-menu bottom left offset-y origin="top right" transition="scale-transition">
      <template v-slot:activator="{ attrs, on }">
        <v-btn class="ml-2" v-on="on" min-width="0">
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </template>

      <v-list :tile="false" nav>
        <v-list-item to="/logout">
          <v-list-item-content>Welcome: {{session.account[0].username}}</v-list-item-content>
        </v-list-item>
        
        <v-list-item to="/logout">
          <v-list-item-icon>
            <v-icon>mdi-account-lock</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Log Out</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
    <br />
  </v-app-bar>
</template>

<style>
#topmenu{
  margin-left: -15px;
  max-width: 630px;
}
.titem {
  font-size: 11px !important;
  font-weight: normal;
}  
</style>

<script>
import { VHover, VListItem } from "vuetify/lib";
import { mapState, mapMutations } from "vuex";
import common from '../mixins/common'
import menuItems from "./menuItems"

export default {
  name: "AppBar",
  components: {
    Settings: () => import("./Settings")
  },
  mixins: [common],
  props: ['drpObjectsOnly','asset_groups'],
  data() {
    return { 
      // drpObjectsOnly: [],
      isMobileMode: false, 
      menus: menuItems
    };
  },
  computed: {
    ...mapState(["activeClass", "drawer", "session", "events"]),
 

    playNotifications: {
      get() {
        return this.$store.state.playNotifications;
      },
      set(val) {
        this.$store.commit("SET_PLAY_MODE", val);
      }
    } 
  },

  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },

  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },

  methods: {
    ...mapMutations(["SET_DRAWER", "SET_ACTIVE_CLASS"]),

    extractTime(dateString){
      return new Date(dateString).toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      });
    },

    loadClickedEvent(eventId){
      this.$store.dispatch("mark_event_read",eventId); 
      this.$router.push({
        name: 'EventDetail',
        params: { id: eventId },
        query:  { id: eventId  },
      })
    },

    reroute(menuObj) {
      this.$store.commit("SET_ACTIVE_CLASS", menuObj.title);
      this.$router.push(menuObj.to);
    },

    setDrawer(drawerState) {
      this.$store.commit("SET_DRAWER", drawerState);
      this.$store.commit("SET_MAIN_MENUCLICK", true); 
    },

    onResize() {
      this.isMobileMode = window.innerWidth < 990;
    }

  },
};
</script>